import Modal from "@/common/elements/Modal";
import { forwardRef, useEffect, useState } from "react";
import InmateMovementDetails from "./InmateMovementDetails";
import {
  generateCurrentLocation,
  hasCheckSecurity,
  isNonEmptyVariable,
  getRefListNameByID,
} from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { setBookings } from "@/slices/bookingsSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import _ from "lodash";
import useDialog from "@/hooks/useDialog";

const HouseAndTracksForm = forwardRef(
  (
    {
      showDetailsPopup,
      setShowDetailsPopup,
      handleSave,
      selectedRow,
      houseFormRef,
      mode,
      isEdit,
      setIsEdit,
      isLoading = false,
      isScheduled = false,
      isReturn = false,
      setScheduled,
      setIsReturn,
      lastCell,
      lastLoan,
      setLastCell,
      setLastLoan,
      setSelectedRow,
      isInLoan,
      handleAddClick,
      from = "",
    },
    ref
  ) => {
    const { showDialog } = useDialog();
    const [isDisabled, setIsDisabled] = useState(false);
    const dispatch = useDispatch();
    const { userDetail } = useSelector((s) => s?.userDetail);
    const { bookings, bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );
    const [showPopUp, setShowPopUp] = useState(false);
    const [showPopUp2, setShowPopUp2] = useState(false);
    const [newFormDisable, setnewFormDisable] = useState(false);
    const [hitTime, setHitTime] = useState(0);
    const fullSearch = useSelector(state => state.fullSearch);

    useEffect(() => {
      if (isReturn) {
        setnewFormDisable(true);
        if (isNonEmptyVariable(lastLoan)) setSelectedRow(lastLoan);
      } else {
        setnewFormDisable(false);
      }
    }, [showDetailsPopup]);

    useEffect(() => {
      if (isEdit) {
        let isShow = hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        );
        if (isShow) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
      } else {
        setIsDisabled(false);
      }
    }, [isEdit]);

    function handleSaveForm() {
      const agency = userDetail?.staff?.organization?.[0]?.agency;
      let houseRef = houseFormRef?.current?.getFormValues();
      if (isNonEmptyVariable(houseRef)) {
        let { inmateLocation, movementStatus, transportDestination } = houseRef;
        if (isNonEmptyVariable(inmateLocation)) {
          if (inmateLocation == "In Jail" && movementStatus == "Complete" && !fullSearch) {
            let involvements = {
              invCreatedBy: userDetail?.staffId,
              invObjType: 3,
              invObjId: bookings?.bookingId,
              invCreatedDate: dayjs().format("MM/DD/YYYY HH:mm:ss"),
              linkedObjectType: "Folders",
              relatedObjectType: "Bookings",
              flagTypeID: 50030004,
              invExpireDate: null,
              invDesc: "",
            };

            dispatch(
              setBookings({
                arrestReports: [
                  {
                    ...bookings?.arrestReports?.[0],
                    currentLocation: generateCurrentLocation(
                      bookings?.inmateTracking?.[0],
                      agency
                    ),
                  },
                ],
                cdInvolvements: [
                  ...(bookings?.cdInvolvements || []),
                  involvements,
                ],
              })
            );
          }
          if (
            inmateLocation != "In Jail" &&
            inmateLocation != "Loan" &&
            movementStatus == "Complete"
          ) {
            if (window.location.pathname === "/inmate-movement") {
              showDialog("info", {
                title: "Info",
                content:
                  "You can only create or complete transport movements from the bookings module.",
                confirmButtonText: "OK",
              });
              return;
            }
            let ar = [];
            if (
              isNonEmptyVariable(bookings?.arrestReports) &&
              bookings?.arrestReports?.length
            ) {
              ar = _.cloneDeep(bookings?.arrestReports);
              let curr = `${inmateLocation} to ${transportDestination || ""}`;
              ar[0].currentLocation = curr;
              dispatch(
                setBookings({
                  arrestReports: [...(ar || [])],
                })
              );
            }
          }
          if (
            inmateLocation != "In Jail" &&
            inmateLocation != "Loan" &&
            movementStatus == "Complete" &&
            isInLoan
          ) {
            if (window.location.pathname === "/inmate-movement") {
              showDialog("info", {
                title: "Info",
                content:
                  "You can only create or complete transport movements from the bookings module.",
                confirmButtonText: "OK",
              });
              return;
            }
            setShowPopUp2(true);
            return;
          }

          if (inmateLocation == "Loan" && movementStatus == "Complete") {
            dispatch(
              setBookings({
                arrestReports: [
                  {
                    ...bookings?.arrestReports?.[0],
                    currentLocation: !fullSearch ? generateCurrentLocation(houseRef, agency) : null,
                  },
                ],
              })
            );
          }
        }
      }
      // setnewFormDisable(true);
      handleSave();
    }

    function handleNewEntry() {
      let newCell = {};

      newCell.bed = null;
      newCell.block = null;
      newCell.cell = null;
      newCell.moveReason = null;
      newCell.approvingOfficerStaffID = null;
      newCell.transportingOfficerStaffID = null;
      newCell.inmateLocation = "In Jail";
      newCell.movementStatus = "Complete";
      newCell.actualDateTime = dayjs();
      newCell.moveReason = "Routine Move";
      newCell.comments = "RETURNING INMATE FROM LOAN TO CELL.";

      setSelectedRow(newCell);
      setnewFormDisable(false);
      setIsReturn(() => false);
      setShowPopUp(() => false);
      setTimeout(() => {
        setShowDetailsPopup(true);
      }, 500);
    }

    function handleReturn() {
      let values = { ...lastCell };

      if (isNonEmptyVariable(values)) {

        const { inmateTrackingID, ...filteredValues } = values;

        const data = {
          ...filteredValues,
          expectedBackDate: isNonEmptyVariable(filteredValues?.expectedBackDateTime)
            ? dayjs(filteredValues?.expectedBackDateTime)?.format("MM/DD/YYYY")
            : null,
          expectedBackTime: isNonEmptyVariable(filteredValues?.expectedBackDateTime)
            ? dayjs(filteredValues?.expectedBackDateTime)?.format("HH:mm")
            : null,
          scheduledDate: isNonEmptyVariable(filteredValues?.scheduleDateTime)
            ? dayjs(filteredValues?.scheduleDateTime)?.format("MM/DD/YYYY")
            : null,
          scheduledTime: isNonEmptyVariable(filteredValues?.scheduleDateTime)
            ? dayjs(filteredValues?.scheduleDateTime)?.format("HH:mm")
            : null,
          actualDate: isNonEmptyVariable(filteredValues?.actualDateTime)
            ? dayjs(filteredValues?.actualDateTime)?.format("MM/DD/YYYY")
            : null,
          actualTime: isNonEmptyVariable(filteredValues?.actualDateTime)
            ? dayjs(filteredValues?.actualDateTime)?.format("HH:mm")
            : null,
          comments: "RETURNING INMATE FROM LOAN TO CELL.",
        };

        dispatch(
          setBookings({
            inmateTracking: [...(bookings?.inmateTracking || []), data],
          })
        );
      }

      setIsReturn(false);
      setShowPopUp(false);
    }

    function handleReturn2() {
      setShowPopUp2(false);
      setShowDetailsPopup(false);
      setTimeout(() => {
        setIsReturn(true);
        handleAddClick();
      }, 100);
    }

    function handleSaveData() {
      const houseRef = houseFormRef?.current?.getFormValues();

      const isLoan = houseRef?.inmateLocation === "Loan";
      const isPermHousing = houseRef?.inmateLocation === "Perm Housing Change";

      const isPending = houseRef?.movementStatus === "Pending";
      const isComplete = houseRef?.movementStatus === "Complete";

      const shouldCheckConflict =
        (isLoan && (isPending || isComplete)) ||
        (isPermHousing && isPending);

      if (shouldCheckConflict) {

        const conflicts = findPendingLoanConflict(houseRef);

        if (conflicts.length > 0) {
          showDialog("error", {
            title: "Loan Schedule Conflicts",
            content: buildLoanConflictWarning(
              houseRef,
              conflicts,
              bookings
            ),
            confirmButtonText: "OK",
          });

          return;
        }
      }

      if (isNonEmptyVariable(typeof setScheduled)) {
        setScheduled(false);
      }

      if (!isInLoan || isScheduled) {
        handleSaveForm();
        return;
      }

      setHitTime((prev) => {
        return prev + 1;
      });

      if (
        isReturn &&
        isNonEmptyVariable(lastCell) &&
        lastCell?.inmateLocation === "In Jail"
      ) {
        setSelectedRow(lastCell);
        setShowPopUp(true);
      } else if (hitTime === 0) {
        handleNewEntry();
      }
      
      handleSaveForm();
    }

    function toDayjs(dateTime, date, time) {
      let result = null;
      if (dateTime) {
        result = dayjs(dateTime);
      } else if (date && time) {
        result = dayjs(`${date} ${time}`, "MM/DD/YYYY HH:mm");
      }
      return result;
    }

    function buildLoanConflictWarning(newLoan, conflicts, bookings) {
      const inmateName = getInmateDisplayName(bookings);

      const outDate = dayjs(newLoan.scheduleDateTime).format("MM/DD/YYYY");
      const outTime = dayjs(newLoan.scheduleDateTime).format("HH:mm");

      const backDate = dayjs(newLoan.expectedBackDateTime).format("MM/DD/YYYY");
      const backTime = dayjs(newLoan.expectedBackDateTime).format("HH:mm");

      let message =
        `${inmateName} has schedule conflicts.\n\n` +
        ` Inmate Movement \n` +
        `Out Date           : ${outDate}\n` +
        `Out Time           : ${outTime}\n` +
        `Expected Back Date : ${backDate}\n` +
        `Expected Back Time : ${backTime}\n\n` +
        ` Conflicts With:\n`;

      conflicts.forEach(({ loan, sequence }) => {
        const conflictStart = dayjs(
          `${loan.scheduledDate} ${loan.scheduledTime}`,
          "MM/DD/YYYY HH:mm"
        ).format("MM/DD/YYYY HH:mm");

        const conflictBack = dayjs(
          `${loan.expectedBackDate} ${loan.expectedBackTime}`,
          "MM/DD/YYYY HH:mm"
        ).format("MM/DD/YYYY HH:mm");

        const approvedBy =
          loan?.approvingOfficerStaffID
            ? getRefListNameByID("", loan.approvingOfficerStaffID, true)
            : " ";

        message +=
          `\nSequence #${sequence}: Loan to ${
            loan.loanDestination || loan.loanType
          }\n` +
          `Type               : ${loan.loanType}\n` +
          `Scheduled At       : ${conflictStart}\n` +
          `Expected Back At   : ${conflictBack}\n` +
          `Approved By        : ${approvedBy}\n`;
      });

      message += `\nYou must resolve all conflicts before saving.`;

      return message;
    }

    function findPendingLoanConflict(newLoan) {
      const conflicts = [];
      const selectedInmateTrackID = selectedRow?.inmateTrackingID;

      const pendingMovements = (bookings?.inmateTracking || []).filter(
        (m) =>
          m?.inmateTrackingID !== selectedInmateTrackID && // skip the one being edited
          (m?.movementStatus === "Pending" || m?.movementStatus === "Complete") &&
          m?.inmateLocation === newLoan?.inmateLocation
      );

      if (!pendingMovements.length) {
        return [];
      }

      const newWindow = getMovementWindow(newLoan);
      if (!newWindow) {
        return [];
      }

      pendingMovements.forEach((movement, index) => {
        const scheduledDateTime =
          movement?.movementStatus === "Complete" &&
          movement?.inmateLocation === "Loan"
            ? movement?.expectedBackDateTime
            : movement?.scheduleDateTime;

        const existingWindow = scheduledDateTime
          ? getMovementWindow({ ...movement, scheduleDateTime })
          : getMovementWindow({
              scheduleDateTime: toDayjs(
                null,
                movement?.scheduledDate,
                movement?.scheduledTime
              ),
              expectedBackDateTime:
                movement?.expectedBackDate && movement?.expectedBackTime
                  ? toDayjs(
                      null,
                      movement?.expectedBackDate,
                      movement?.expectedBackTime
                    )
                  : null,
            });

        if (!existingWindow) return;

        const overlap =
          newWindow.start.isBefore(existingWindow.end) &&
          newWindow.end.isAfter(existingWindow.start);

        if (overlap) {
          conflicts.push({
            loan: movement,
            sequence: index + 1,
            window: existingWindow,
          });
        }
      });

      return conflicts;
    }

    function getInmateDisplayName(bookings) {
      const firstName = bookings?.firstName || bookings?.bio?.[0]?.fName || "";
      const lastName = bookings?.lastName || bookings?.bio?.[0]?.lName || "";

      const name =
        firstName || lastName
          ? `${lastName}${lastName && firstName ? ", " : ""}${firstName}`
          : "Inmate";
      return name;
    }

    function getMovementWindow(movement) {
      const start = 
        (movement?.inmateLocation === "Loan" && movement?.movementStatus === "Complete")
        ? toDayjs(movement.expectedBackDateTime)
        : toDayjs(movement?.scheduleDateTime);
      if (!start?.isValid()) {
        return null;
      }

      const end = movement?.expectedBackDateTime
        ? toDayjs(movement.expectedBackDateTime)
        : start;

      if (!end?.isValid()) {
        return null;
      }

      const window = { start, end };
      return window;
    }

    return (
      <>
        {showDetailsPopup && (
          <Modal
            header={"Inmate Movement Details"}
            show={showDetailsPopup}
            size="xl"
            onHide={() => {
              setShowDetailsPopup(false);
              setnewFormDisable(false);
              setIsReturn(false);
              setHitTime(0);
            }}
            footerActions={[
              {
                key: "save",
                text: "Save",
                isLoading: isLoading,
                onClick: () => {
                  handleSaveData();
                },
                disabled: !bookingsFieldsEnabled || isDisabled,
              },
            ]}
            footerCloseAction={() => {
              setIsEdit(false);
              setIsReturn(false);
            }}
            footerCloseActionText="Close"
          >
            <InmateMovementDetails
              data={selectedRow}
              ref={houseFormRef}
              bookingsFieldsEnabled={bookingsFieldsEnabled}
              mode={mode}
              isScheduled={isScheduled}
              isInLoan={isInLoan}
              isReturn={isReturn}
              newFormDisable={newFormDisable}
            />
          </Modal>
        )}
        {showPopUp && lastCell?.inmateLocation == "In Jail" && (
          <Modal
            header={"Inmate Movement Details"}
            show={showPopUp}
            size="xl"
            onHide={() => setShowPopUp(false)}
            footerActions={[
              {
                key: "yes",
                text: "Yes",
                onClick: () => {
                  handleReturn();
                },
              },
              {
                key: "no",
                text: "No",
                onClick: () => {
                  handleNewEntry();
                },
              },
            ]}
            footerCloseAction={() => setShowPopUp(false)}
            footerCloseActionText="Close"
          >
            Are you moving the inmate back to{" "}
            {isNonEmptyVariable(lastCell?.block)
              ? `Cell:- ${[lastCell?.block, lastCell?.cell, lastCell?.bed]
                  .filter((v) => isNonEmptyVariable(v))
                  .join(" ")}?`
              : `Holding:- ${lastCell?.holdingCell || ""}?`}
          </Modal>
        )}

        {showPopUp2 && (
          <Modal
            header={"Inmate Movement Details"}
            show={showPopUp2}
            size="xl"
            onHide={() => setShowPopUp2(false)}
            footerActions={[
              {
                key: "return",
                text: "Return",
                // isLoading: isLoading,
                onClick: () => {
                  handleReturn2();
                },
                // disabled: !bookingsFieldsEnabled || isDisabled,
              },
              {
                key: "cancel",
                text: "Cancel",
                // isLoading: isLoading,
                onClick: () => {
                  () => setShowPopUp2(false);
                },
                // disabled: !bookingsFieldsEnabled || isDisabled,
              },
            ]}
            footerCloseAction={() => setShowPopUp2(false)}
            footerCloseActionText="Close"
          >
            This inmate is currently on a Loan. if you are the inmate to the
            facility, you should use the "inmate return" button Press{" "}
            <b>Return </b> to return inmate from loan
          </Modal>
        )}
      </>
    );
  }
);

export default HouseAndTracksForm;
